// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSecurityScanOutlinedSvg from "@fishx/icons-svg/es/asn/PSecurityScanOutlined";
import FishxIcon from '../components/FishxIcon';

var PSecurityScanOutlined = function PSecurityScanOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSecurityScanOutlinedSvg
  }));
};

PSecurityScanOutlined.displayName = 'PSecurityScanOutlined';
export default React.forwardRef(PSecurityScanOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSecurityScanOutlined.js
// module id = 3624
// module chunks = 0